import { observer } from 'mobx-react';
import * as React from 'react';
import ScheduledToastStore from '../../../ToastsStore/ScheduledToastStore';
import { L, T } from '../../../Translations';
import EventAlertIcon from '../../Cutesies/EventAlertIcon';
import * as style from '../style.module.css';

interface Props {
  store: ScheduledToastStore;
}

const ActiveTemplate: React.FC<Props> = ({ store }) => {
  return (
    <div className={style.content}>
      <div className={style.icon}>
        <EventAlertIcon />
      </div>
      <div className={style.details}>
        <h2 className={style.title}>
          <T kind="Your Live Meeting has started!" />
        </h2>
        <p
          className={style.description}
          data-test-toast-description={store.scheduledToast.title.text}
        >
          <T
            kind="The {{title}} event started at <time/>."
            title={store.scheduledToast.title.text}
            time={<L localizeable={store.scheduledToast.startAt} format="time-of-day" />}
          />
        </p>
      </div>
    </div>
  );
};

export default observer(ActiveTemplate);
